import { styled } from "@linaria/react";
import { match } from "ts-pattern";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

import { TextSize } from "./Text";

const StyledRequiredMarker = withTheme(styled.span<PropsWithTheme<{ $size: TextSize }>>`
  color: ${({ theme }) => theme.color.text.error};
  font-size: ${({ theme, $size }) => {
    return match($size)
      .with(TextSize.CAPTION, () => theme.font.sans.size.caption)
      .with(TextSize.BODY_SM, () => theme.font.sans.size.body_sm)
      .with(TextSize.BODY_MD, () => theme.font.sans.size.body_md)
      .with(TextSize.BODY_LG, () => theme.font.sans.size.body_lg)
      .with(TextSize.HEADING_SM, () => theme.font.sans.size.heading_sm)
      .with(TextSize.HEADING_MD, () => theme.font.sans.size.heading_md)
      .with(TextSize.HEADING_LG, () => theme.font.sans.size.heading_lg)
      .exhaustive();
  }};
  font-weight: ${({ theme, $size }) => {
    return match($size)
      .with(TextSize.CAPTION, () => theme.font.sans.weight.medium)
      .with(TextSize.BODY_SM, () => theme.font.sans.weight.medium)
      .with(TextSize.BODY_MD, () => theme.font.sans.weight.medium)
      .with(TextSize.BODY_LG, () => theme.font.sans.weight.medium)
      .with(TextSize.HEADING_SM, () => theme.font.sans.weight.medium)
      .with(TextSize.HEADING_MD, () => theme.font.sans.weight.medium)
      .with(TextSize.HEADING_LG, () => theme.font.sans.weight.medium)
      .exhaustive();
  }};
  line-height: ${({ theme, $size }) => {
    return match($size)
      .with(TextSize.CAPTION, () => theme.font.sans.height.caption)
      .with(TextSize.BODY_SM, () => theme.font.sans.height.body_sm)
      .with(TextSize.BODY_MD, () => theme.font.sans.height.body_md)
      .with(TextSize.BODY_LG, () => theme.font.sans.height.body_lg)
      .with(TextSize.HEADING_SM, () => theme.font.sans.height.heading_sm)
      .with(TextSize.HEADING_MD, () => theme.font.sans.height.heading_md)
      .with(TextSize.HEADING_LG, () => theme.font.sans.height.heading_lg)
      .exhaustive();
  }};
  letter-spacing: ${({ theme, $size }) => {
    return match($size)
      .with(TextSize.CAPTION, () => theme.font.sans.spacing.caption)
      .with(TextSize.BODY_SM, () => theme.font.sans.spacing.body_sm)
      .with(TextSize.BODY_MD, () => theme.font.sans.spacing.body_md)
      .with(TextSize.BODY_LG, () => theme.font.sans.spacing.body_lg)
      .with(TextSize.HEADING_SM, () => theme.font.sans.spacing.heading_sm)
      .with(TextSize.HEADING_MD, () => theme.font.sans.spacing.heading_md)
      .with(TextSize.HEADING_LG, () => theme.font.sans.spacing.heading_lg)
      .exhaustive();
  }};

  padding-left: ${({ $size }) => {
    return match($size)
      .with(TextSize.CAPTION, () => "0.5px")
      .with(TextSize.BODY_SM, () => "1px")
      .with(TextSize.BODY_MD, () => "1px")
      .with(TextSize.BODY_LG, () => "1px")
      .with(TextSize.HEADING_SM, () => "2px")
      .with(TextSize.HEADING_MD, () => "2px")
      .with(TextSize.HEADING_LG, () => "2px")
      .exhaustive();
  }};
`);

interface RequiredMarkerProps {
  size?: TextSize;
}

const RequiredMarker = ({ size = TextSize.BODY_MD }: RequiredMarkerProps) => {
  return <StyledRequiredMarker $size={size}>*</StyledRequiredMarker>;
};

export default RequiredMarker;
